var _defs, _path, _path2, _path3, _path4, _path5, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIvicosBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164.74 48.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#201f1e;}.cls-2{fill:url(#Unbenannter_Verlauf_4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_4",
    x1: 211.8,
    y1: 419.06,
    x2: 263.64,
    y2: 428.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00a1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#019dd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0491c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#097eaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0f6383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#174251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#201f1e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.53,396.33a6,6,0,1,0,6,5.95A6,6,0,0,0,274.53,396.33Z",
    transform: "translate(-214.85 -396.33)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.07,420.79a7.35,7.35,0,0,1,6.78,4.75l8.37-4.44a16.9,16.9,0,0,0-15.15-9.25c-9.31,0-16.85,6.85-16.85,16.54s7.54,16.54,16.85,16.54a16.9,16.9,0,0,0,15.15-9.25l-8.37-4.44a7.36,7.36,0,0,1-6.78,4.76,7.62,7.62,0,0,1,0-15.21Z",
    transform: "translate(-214.85 -396.33)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.05,411.85a16.54,16.54,0,1,0,16.67,16.54A16.54,16.54,0,0,0,335.05,411.85Zm0,24.15c-4,0-7-3.11-7-7.61s3-7.6,7-7.6,7,3.1,7,7.6S339,436,335.05,436Z",
    transform: "translate(-214.85 -396.33)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.72,424.08l-2.86-.76c-2.91-.76-3.48-1.27-3.48-2.15s1.14-1.46,2.85-1.46a10.12,10.12,0,0,1,6.21,2.41l5.2-5.77a14.67,14.67,0,0,0-11-4.5c-6.78,0-11.72,4-11.85,9.89-.12,5.07,2.85,9.12,8.75,10.58l2,.51c3.24.82,4.38,1.14,4.38,2.34s-1.46,1.71-3.43,1.71a8.74,8.74,0,0,1-6.9-3l-6.21,5.64c3,3.74,7.73,5.45,12.54,5.45,7.29,0,12.68-4.18,12.68-10.33C379.59,429.28,376.36,425.6,370.72,424.08Z",
    transform: "translate(-214.85 -396.33)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.05,412.55h9.57v31.68h-9.57Zm4.75-16.22a6,6,0,1,0,6,5.95A6,6,0,0,0,220.8,396.33Zm35,16.22-7.67,19.2-7.73-19.2H229.77l13.88,31.68h8.87l13.88-31.68Z",
    transform: "translate(-214.85 -396.33)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.99 16.22 53.41 28.97 53.41 47.91 62.98 47.91 62.98 16.22 58.99 16.22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvicosBlack);
export default __webpack_public_path__ + "static/media/ivicos-black.dbc3318ac56ada456c20ad6823fed0ac.svg";
export { ForwardRef as ReactComponent };